export default {"src":"/_next/static/media/material-symbols_verified-rounded.16eb77ae.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};